"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssertionsOutputDtoSchema = exports.getAssertionsInputDtoSchema = exports.getDefinitionOutputDtoSchema = exports.getDefinitionInputDtoSchema = exports.listDefinitionsOutputDtoSchema = exports.listDefinitionsInputDtoSchema = exports.requirementDefinitionWithAssertionsDtoSchema = exports.assertionDefinitionDtoSchema = exports.requirementDefinitionDtoSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const query_builder_helpers_js_1 = require("./query-builder-helpers.js");
exports.requirementDefinitionDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    slug: zod_1.z.string(),
    slugPrefix: zod_1.z.string().nullable(),
    ownerId: zod_1.z.string(),
    name: zod_1.z.string().describe('Short human-readable label for the requirement'),
    description: zod_1.z.string(),
    assertionsEnumerable: zod_1.z
        .boolean()
        .describe('False when the assertion definitions are minted at run time; fetch them by id with getAssertions.'),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.assertionDefinitionDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    slug: zod_1.z.string(),
    ownerId: zod_1.z.string(),
    requirementDefinitionId: zod_1.z.string(),
    name: zod_1.z.string().describe('Short human-readable label for the assertion'),
    description: zod_1.z.string(),
    lifecycle: sigma_engine_shared_1.RequirementsV2.AssertionDefinitionLifecycleSchema,
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.requirementDefinitionWithAssertionsDtoSchema = zod_1.z.object({
    definition: exports.requirementDefinitionDtoSchema,
    assertions: exports.assertionDefinitionDtoSchema.array(),
});
exports.listDefinitionsInputDtoSchema = zod_1.z.object({
    ownerId: zod_1.z.string().optional().describe('Restrict the listing to requirements owned by this organization.'),
    includeAllLifecycles: zod_1.z
        .boolean()
        .optional()
        .describe('When true, include `lifecycle != active` assertion definitions (drafts, retired, deleted). Defaults to false: only active definitions are returned.'),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.requirementDefinitionFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.RequirementsV2.requirementDefinitionFilterSchema).optional(),
});
exports.listDefinitionsOutputDtoSchema = zod_1.z.object({
    requirements: exports.requirementDefinitionWithAssertionsDtoSchema.array(),
});
exports.getDefinitionInputDtoSchema = zod_1.z.union([
    zod_1.z.object({ id: zod_1.z.string() }).strict(),
    zod_1.z.object({ slug: zod_1.z.string() }).strict(),
]);
exports.getDefinitionOutputDtoSchema = exports.requirementDefinitionWithAssertionsDtoSchema;
exports.getAssertionsInputDtoSchema = zod_1.z.object({
    ids: zod_1.z.string().array().min(1).max(100).describe('Assertion definition ids to resolve.'),
    includeAllLifecycles: zod_1.z
        .boolean()
        .optional()
        .describe('When true, include non-active definitions. Requires manage across all owners (staff).'),
});
exports.getAssertionsOutputDtoSchema = zod_1.z.object({
    assertions: exports.assertionDefinitionDtoSchema.array(),
});
//# sourceMappingURL=list-definitions.dto.js.map